// extracted by mini-css-extract-plugin
module.exports = {"bannerWrapper":"CmsScrollCardsList_bannerWrapper__F9VDX","scrollableStyle":"CmsScrollCardsList_scrollableStyle__lO1BH"};